
(function (app) {
    var types = [
        { ShortName: "ApplicationSigned", LongName: "Application Signed" },
        { ShortName: "SubmittedToFIG", LongName: "Submitted To FIG" },
        { ShortName: "SubmittedToCarrier", LongName: "Submitted To Carrier" },
        { ShortName: "Pending", LongName: "Pending" },
        { ShortName: "Approved", LongName: "Approved" },
        { ShortName: "Issued", LongName: "Issued" },
        { ShortName: "Inforce", LongName: "Inforce" },
        { ShortName: "Canceled", LongName: "Canceled" },
        { ShortName: "Declined", LongName: "Declined" },
        { ShortName: "FreeLook", LongName: "Free Look" },
        { ShortName: "NotTaken", LongName: "Not Taken" },
        { ShortName: "Postponed", LongName: "Postponed" },
        { ShortName: "Surrendered", LongName: "Surrendered" },
        { ShortName: "Withdrawn", LongName: "Withdrawn" },
        { ShortName: "AwaitingFunds", LongName: "Awaiting Funds" },
        { ShortName: "SentToCustodian", LongName: "Sent To Custodian" },
        { ShortName: "AwaitingApproval", LongName: "Awaiting Approval" },
        { ShortName: "OKToTrade", LongName: "OK To Trade" },
        { ShortName: "AddedToTradeSheet", LongName: "Added To Trade Sheet" },
        { ShortName: "Invested", LongName: "Invested" },
        { ShortName: "Blocked", LongName: "Blocked" },
        { ShortName: "Closed", LongName: "Closed" },
        { ShortName: "HoldAccountFunded", LongName: "Hold Account Funded" },
        { ShortName: "PartiallyFunded", LongName: "Partially Funded" }
    ];

    app.provider("statusTypes", [function () {
        this.$get = ["_", function (_) {
            var service = {};

            service.get = function () {
                return types;
            };

            service.toShort = function (name) {
                var elem = _.find(types, function (t) {
                    return t.LongName === name;
                });

                return elem ? elem.ShortName : name;
            };

            service.toLong = function (name) {
                var elem = _.find(types, function (t) {
                    return t.ShortName === name;
                });

                return elem ? elem.LongName : name;
            };

            return service;
        }];
    }]);
})(window.app); //jshint ignore:line